import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
let InspectionListItemSkeleton = class InspectionListItemSkeleton extends Vue {
};
InspectionListItemSkeleton = __decorate([
    Component({})
], InspectionListItemSkeleton);
export default InspectionListItemSkeleton;
